module.exports = __webpack_public_path__ + "img/Credit.89215522.svg";